import AlertList from './AlertList';

export default AlertList;
export * from './AlertList';
